const TAB_KEY = 'assignedDrivers'
export default {
  data () {
    return {
      assignedDriversTabKey: TAB_KEY
    }
  },

  computed: {
    assignedDriversCreateConfig () {
      return {
        title: this.$t('base/user.assigned_drivers'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.personPickerComponent,
            dataKey: 'people',
            inputFieldConfig: {
              label: this.$t('base/user.assigned_drivers')
            }
          }
        ]
      }
    }
  }
}
